const makeName = (name, key) => (name ? `${name}.${key}` : key);

export default makeName;
